<template>
  <div style="margin-top: -30px; margin-bottom: 50px; display: flex; flex-direction: column; justify-content: space-between; align-items: center;">
    <Row1 />
  </div>
</template>

<script>
import Row1 from './Row1.vue'

export default {
  metaInfo: {
    title: 'Easy Tailor App - ios app and android app',
    htmlAttrs: {
      lang: 'en',
      amp: true
    }
  },
  components: {Row1}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/views/AppDownload/Index.vue